import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { ClipLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import { usePackagesContext } from "../../../context/packages_context";
import { ICON_CASH_COIN } from "../../../utils/icons";
import { Button } from "../../../styles";
import Api from "../../../api/axios";
import { useUserContext } from "../../../context/user_context";

const PayForFree = (props) => {

    const [load, setload] = useState(false);

    const navigate = useNavigate();

    const { amount_th, name, duration_days, id } = props;

    const { btoken, usertoken } = useUserContext();



    const {
        showPayForFree, closePayForFree,
    } = usePackagesContext();

    const updatePay = (e) => {
        e.preventDefault();
        if ((id)) {
            setload(true);
            const data = {
                btoken, usertoken,
                packageid: id,
                amount: amount_th,
                duration_days
            };
            Api.post(`/subscribeBusiness`, data)
                .then((res) => {
                    if (res.success === false) {
                        toast.warn(res.message);
                        setload(false);
                    } else {
                        setload(false);
                        toast.success(res.message);
                        setTimeout(() => {
                            navigate("/user/settings/billing");
                        }, 2000);
                    }
                })
                .catch((error) => {
                    setload(false);
                });
        } else {
            setload(false);
            toast.warn("Empty Fields !!!");
        }
    };

    function payConfirm(e) {
        if (window.confirm(`Are you sure you want activate the subscription of ${ name } package for ${ duration_days } days ?`)) {
            updatePay(e);
        }
    }

    return (
        <>
            <Modal
                show={showPayForFree}
                onHide={closePayForFree}
                backdrop="static"
                keyboard={true}
                centered
                size="lg"
            >
                <Modal.Body>
                    <Modal.Header closeButton ></Modal.Header>

                    {load ?
                        <div className="mt-5 text-center">
                            <ClipLoader color={"#023676"} loading={load} speedMultiplier="1.2" />
                            <div className="mt-4 mb-5">
                                <h5 className="fw-light">
                                    Please wait, your transaction is processing{" "}
                                </h5>
                                <h6> Do not refresh page!!! </h6>
                            </div>
                        </div>
                        : (
                            <>
                                <div className="mt-3 text-center">
                                    <h5 className="fw-light pry-text">
                                        Payment for {name} Package
                                    </h5>
                                    <hr />
                                    <span className="h1 pry-text">
                                        {ICON_CASH_COIN}
                                    </span>
                                    <h5 className=" fw-light pry-text mt-2">
                                        Amount
                                    </h5>
                                    <h1 className=" pry-text mt-3">
                                        ₦{amount_th}
                                    </h1>
                                    <hr className="mt-5" />
                                    <Button
                                        pry
                                        className='btn mt-2 mb-4'
                                        onClick={e => payConfirm(e)}
                                    >
                                        Pay with wallet
                                    </Button>
                                </div>
                            </>
                        )}

                </Modal.Body>
            </Modal>
        </>
    );
};

export default PayForFree;
